<template>
  <div class="container">
        <Notebook />
  </div>
</template>

<script>
import Notebook from './Notebook'
export default {
  name: 'Home',
  components: {
    Notebook,
  }

}
</script>

<style>

</style>